<template>
    <modal-controller-base content-class="light-light-background">
        <template #header>
            <filter-header :title="$t('object.filter')" @back="modalController.dismiss()"/>
        </template>

        <filter-interface
            style="max-height: 350px;"
            v-model:tempCategory="tempCategory"
            v-model:tempTags="tempTags"
            v-model:withQuantity="withQuantity"
            v-model:sort-direction="tempSortDirection"
            @reset="resetChanges"
            @apply="applyChanges"
            :supplier-id="supplierId"
            :own-categories="listStore.recommendedTags.data"
            is-list
        />
    </modal-controller-base>
</template>

<script setup lang="ts">
import { modalController } from "@ionic/vue";
import { ref, computed, onMounted } from "vue";
import { route } from "@/router";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import FilterHeader from "@/components/modal/FilterHeader.vue";
import FilterInterface from "@/components/modal/FilterInterface.vue";

import { useSupplierStore } from "@/stores/suppliers";
import { useListStore } from "@/stores/lists";
import { usePersistentStore } from "@/stores/persistent";

import { isApp } from "@/functions/enviroment";

import { useLoader } from "@/composables/useLoader";
import { useCatalogFilter } from "@/composables/viewFunctions/useCatalogFilter";

import { SORT_METHOD } from "@/types/enum/propEnum";

const props = defineProps<{ supplierId: string; }>()

const listStore = useListStore()
const supplierStore = useSupplierStore()
const { showLoading } = useLoader()

const tempCategory = ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.category)))
const tempTags = ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.tags)))
const withQuantity = ref<boolean>(JSON.parse(JSON.stringify(listStore.listFilter.withQuantity)))

const listId = computed<string>(() => route.value.params.listId as string)
const locationId = computed<string>(() => route.value.params.locationId as string)

const { tempSortDirection, getCatalogItems } = useCatalogFilter(listId.value)

const resetChanges = async (): Promise<void> => {
    if (!listId.value) {
        supplierStore.catalogFilter.sortDirection = SORT_METHOD.ALPH_ASC
    } else {
        listStore.listFilter.sortDirection = SORT_METHOD.MANUAL
    }
    listStore.listFilter.category = {}
    listStore.listFilter.tags = {}
    listStore.listFilter.withQuantity = false

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
}

const applyChanges = async (): Promise<void> => {
    listStore.listFilter.sortDirection = tempSortDirection.value
    listStore.listFilter.tags = tempTags.value
    listStore.listFilter.category = tempCategory.value
    listStore.listFilter.withQuantity = withQuantity.value

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
}

onMounted(() => {
    if (usePersistentStore().offlineMode) return
    if (props.supplierId) supplierStore.getSupplierCategories(locationId.value, props.supplierId)
    listStore.getTags(locationId.value)
})
</script>
